//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export bankrecledgerconfig
export const EncryptConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/agentPanel/encryption",
      component: FuseLoadable({
        loader: () => import("./AccountEncryptDecrypt.js")
      })
    }
  ]
  //end routes
};
